export const queryKeys = {
  purchaseOrders: ['purchase-orders'] as const,
  purchaseOrder: (id: number) => ['purchase-orders', id] as const,
  purchaseOrderLogistics: (id: number) => ['purchase-orders', id, 'logistics'] as const,

  inventoryItems: ['inventory-items'] as const,
  inventoryItem: (skuCode: string) => ['inventory-items', skuCode] as const,
  inventoryLedger: (skuCode: string) => ['inventory-items', skuCode, 'ledger'] as const,
  lowStockAlerts: ['inventory', 'low-stock'] as const,

  deviceAssets: ['device-assets'] as const,
  deviceAsset: (id: number) => ['device-assets', id] as const,

  customers: (filter?: object) => ['customers', filter] as const,
  customer: (id: number) => ['customers', id] as const,

  dashboard: ['dashboard'] as const,
  dashboardStats: ['dashboard', 'stats'] as const,
  dashboardOverview: ['dashboard', 'overview'] as const,

  salesQuotes: (filter?: string) => ['sales', 'quotes', filter] as const,
  salesQuote: (id: number) => ['sales', 'quotes', id] as const,
  salesNegotiations: (filter?: string) => ['sales', 'negotiations', filter] as const,
  salesNegotiation: (id: number) => ['sales', 'negotiations', id] as const,

  workOrders: (filter?: object) => ['work-orders', filter] as const,
  workOrder: (id: number) => ['work-orders', id] as const,
  workOrderTimeline: (id: number) => ['work-orders', id, 'timeline'] as const,

  maintenanceOrders: (filter?: object) => ['maintenance-orders', filter] as const,
  maintenanceOrder: (id: number) => ['maintenance-orders', id] as const,

  engineers: (keyword?: string) => ['engineers', keyword] as const,

  systemEmployees: (filter?: object) => ['system', 'employees', filter] as const,
  systemRoles: ['system', 'roles'] as const,
  systemPermissions: ['system', 'permissions'] as const,
  systemDictionaries: (filter?: object) => ['system', 'dictionaries', filter] as const,
  systemDictionaryItems: (dictionaryId: number) => ['system', 'dictionaries', dictionaryId, 'items'] as const,

  medicalDeviceBrands: (filter?: object) => ['basic-information', 'medical-device-brands', filter] as const,
  medicalDeviceCatalogs: ['basic-information', 'medical-device-classification-catalogs'] as const,
  suppliers: (filter?: object) => ['basic-information', 'suppliers', filter] as const,
} as const

export type QueryKeys = typeof queryKeys
